import axios from "axios";
import config from "../../../config";

/**
 * Knowledge base calls the shared knowledgeBaseAPI doesn't cover (items 224–231).
 * All but the status read are owner-only on the backend (requireSuperAdmin),
 * like upload, process and delete already are.
 *
 *   PATCH /api/kb/documents/:id { category_id }             move to a category (224)
 *   POST  /api/kb/documents/:id/cancel                      stop processing (225)
 *   GET   /api/kb/documents/:id/status                      stage, progress, stage_timings (226)
 *   POST  /api/kb/documents/process { document_ids, chunk_size, overlap, force }  reprocess (227)
 *   GET   /api/kb/documents/:id/chunks?page=&limit=         text chunks (228)
 *   POST  /api/kb/search { query }                          sources, nothing written (229)
 *   GET   /api/kb/documents/:id/agents                      { mirrored, agents } (230)
 */
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } });
const url = (path) => `${config.API_BASE_URL}/api/kb${path}`;

export const moveDocument = (id, categoryId) =>
  axios.patch(url(`/documents/${id}`), { category_id: categoryId ?? null }, auth());

export const cancelDocument = (id) => axios.post(url(`/documents/${id}/cancel`), {}, auth());

export async function documentStatus(id) {
  const r = await axios.get(url(`/documents/${id}/status`), auth());
  return r.data?.data || null;
}

export const reprocessDocument = (id, { chunkSize, overlap }) =>
  axios.post(url("/documents/process"), { document_ids: [id], chunk_size: chunkSize, overlap, force: true }, auth());

export async function documentChunks(id, page = 1, limit = 20) {
  const r = await axios.get(url(`/documents/${id}/chunks`), { ...auth(), params: { page, limit } });
  return { chunks: r.data?.data || [], total: r.data?.pagination?.total ?? null, pages: r.data?.pagination?.pages ?? 1 };
}

export async function searchKnowledge(query) {
  const r = await axios.post(url("/search"), { query }, auth());
  return r.data?.data || [];
}

export async function documentAgents(id) {
  const r = await axios.get(url(`/documents/${id}/agents`), auth());
  const d = r.data?.data || {};
  return { mirrored: !!d.mirrored, agents: d.agents || [] };
}
